'use client';

import { c as _c } from "react/compiler-runtime";
import { useToggleSort } from '@/shared/hooks/useToggleSort.mjs';
import { SORT_ORDER_KEY } from '@/shared/preferences/sortOrder.mjs';

/**
 * Cookie-backed sort preference for the shared event log component.
 *
 * Takes the server-read initial value as a prop so the first render
 * matches the user's stored preference. Returns `[sortOrder, toggleSortOrder]`.
 */
export function useEventLogSort(initial) {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["desc", "asc"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useToggleSort(SORT_ORDER_KEY, initial, t0);
}